import React, { useEffect, useState, useRef } from "react";
import {
  Row,
  Col,
} from "reactstrap";
import { useFetch2 } from "components/utils/authenticatedHook";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import LottieLoader from "../../components/LottieLoader";
import lottieLoaderFile from "../../files/animation/loading.json";
import lottieEmptyFile from "../../files/animation/empty_new.json";
import moment from "moment";
import VitalsIcon from "../../files/vitals.jpg";
import _ from "lodash";
import { pasteValue } from "../Reusable/OnPasteValue";
import ExtremeExceptionsDetails from "./ExtremeExceptionsDetails";
import hypertensionImages from "../../files/blood-pressure.png";

const ExtremeExpectations = () => {
  const [{ response, error, isLoading }, doFetch, sendError] = useFetch2();
  const [{ response: readingTypeAndConditions, error: readingTypeAndConditionsError, isLoading: readingTypeAndConditionsLoading }, doFetch2, getError] = useFetch2();
  const { data = [], limit = 0, page = 0, totalPages = 0, total = 0 } = response || {};
  const [search, setSearch] = useState("");

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {"   "}Showing {from} to {to} of {size} Results
    </span>
  );
  const options = {
    page: parseInt(page || 0),
    sizePerPage: parseInt(limit || 0),
    totalSize: parseInt(total || 0),
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    hideSizePerPage: parseInt(total) == 0 ? true : false, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    showTotal: parseInt(total) == 0 ? false : true,
    paginationTotalRenderer: customTotal,
    sizePerPageList: [
      {
        text: "25",
        value: 25,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "200",
        value: 200,
      },
    ], // A numeric array is also available. the purpose of above example is custom the text
  };

  useEffect(() => {
    getExtremeExpectations()
    doFetch2({
      url: "/get-extreme-reading-type-and-condition",
      method: "GET",
    });
  }, []);

  function getExtremeExpectations(filter) {
    const query = {
      page: filter?.page ?? 1,
      limit: filter?.limit ?? 25,
      sortOrder: filter?.sortOrder ?? "desc",
      sortFiled: filter?.sortFiled ?? "createdAt",
    };
    if ((filter && filter?.search) || search) {
      query.search = filter?.search || search;
    }
    doFetch({
      url: "/get-extreme-reading-expectations",
      method: "GET",
      disableWait: true,
      query: query,
    });
  };
  function reloadData(event) {
    if (event) {
      getExtremeExpectations()
    }
  }
  function pagination(type, { page, sizePerPage, filters, sortField, sortOrder }) {
    let data = {
      page: page,
      limit: sizePerPage,
    };
    if (sortField) {
      data.sortFiled = sortField;
    }
    if (sortOrder) {
      data.sortOrder = sortOrder;
    }
    getExtremeExpectations(data)
  }

  function withIcon(cell) {
    let icon;
    switch (cell) {
      case "Vitals":
        icon = VitalsIcon;
        break;
      case "Event Expectation":
        icon = hypertensionImages;
        break;
      default:
        break;
    }
    return (
      <span>
        <img src={icon} className="mr-2" alt="image" />
        {cell == "Weight" ? "Weight Difference" : cell}
      </span>
    );
  }

  const debounceTimeout = useRef();

  function handleSearch(event) {
    const value = event.target.value;
    setSearch(value);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      getExtremeExpectations({ search: value });
    }, 800);
  }

  return (
    <div className="mt-4">
      <div className="d-flex w-100 align-items-center" style={{ gap: 12 }}>
        <input
          type="text"
          className="form-control input-date-filter remove-bottom-margin"
          id="exampleInputName1Test"
          style={{
            fontSize: "18px",
            borderRadius: "8px",
            boxShadow: "none",
            height: "44px",
            flex: 1,
          }}
          placeholder="Search expectation name, message..."
          onChange={handleSearch} // Call handleChange on every input change
          onPaste={(e) => {
            e.preventDefault();
            const event = pasteValue(e);
            handleSearch(event);
          }}
        />
      </div>
      <div className="care-plan-header-background" style={{ marginTop: 20 }}>
        <Row>
          <Col sm="12" className="center-label remove-table-padding">
            <h4 className="text-center title-device" style={{ marginLeft: 25 }}>
              <i className="mdi mdi-alert-decagram"></i> Event Expectation - Retest Logic
            </h4>
          </Col>
        </Row>
      </div>
      <div className="scrollbar-table-cls">
      <BootstrapTable
        remote={{
          sort: false,
          pagination: true,
          filter: true,
          search: true,
        }}
        wrapperClasses="table-responsive"
        keyField="_id"
        noDataIndication={() => {
          return (
            <div>
              {isLoading && (
                <LottieLoader
                  loadLoop={true}
                  autoplayLoop={true}
                  source={lottieLoaderFile}
                  Lheight={150}
                  Lwidth={150}
                  subTitle={"Please Wait ..."}
                />
              )}
              {!isLoading && (
                <LottieLoader
                  loadLoop={true}
                  autoplayLoop={true}
                  source={lottieEmptyFile}
                  Lheight={300}
                  Lwidth={300}
                  title={"Sorry! No data found"}
                  subTitle={"We can't find any event expectation - retest logic data."}
                />
              )}
            </div>
          );
        }}
        data={isLoading ? [] : data}
        columns={[
          {
            dataField: "name",
            text: "Name",
            sort: true,
            formatter: (cell) => <div>{cell ? cell : "-"}</div>,
          },
          {
            dataField: "ruleType",
            text: "Expectation Type",
            sort: true,
            formatter: withIcon,
          },
          {
            dataField: "readingType",
            text: "Reading Type",
            sort: true,
            formatter: (cell) => <div>{cell ? cell.description : "-"}</div>,
          },
          {
            dataField: "condition",
            text: "Expectation",
            sort: false,
            formatter: (cell, row) => {
              if(row.readingType && row.readingType._id == "5bb306382598931ffbd1b625"){
                const weight = row.valueProperty && row.valueProperty[0].gainLossPerDay ? row.valueProperty[0].gainLossPerDay : ""
                return `${weight} Per Day`
              }else{
              if (cell == "<=") {
                return "Less than or equal to";
              } else if (cell == ">=") {
                return "Greater than or equal to";
              } else if (cell == "between") {
                return "Between";
              }
              }
            },
          },
          {
            dataField: "valueProperty",
            text: "Value",
            sort: false,
            formatter: (cell, row) => {
              if (Array.isArray(cell) && cell.length > 0 && row.readingType && row.readingType._id !== "5bb306382598931ffbd1b625") {
                return (
                  <div>
                    {cell.map((item, idx) => (
                      <div key={item.readingSubTypeId || idx} style={{ display: "block", lineHeight: "1.3" }}>
                        <strong>{item.name === "pulseRate" ? "Heart Rate" : item.name}:</strong>{" "}
                        {item.value || item.minValue || item.maxValue
                          ? [
                            item.value && `${item.value}`,
                            item.minValue && `Min: ${item.minValue}`,
                            item.maxValue && `Max: ${item.maxValue}`,
                          ]
                            .filter(Boolean)
                            .join(" | ")
                          : "-"}
                      </div>
                    ))}
                  </div>
                );
              } else {
                return <div>-</div>;
              }
            }
          },
          {
            dataField: "notifySelf",
            text: "Notification",
            sort: false,
            headerStyle: (colum, colIndex) => {
              return { width: '320px', textAlign: 'center', padding: "16px", fontSize: "16px", color: "#070707" };
            },

            formatter: (cell, row) => {
              if ((row.notifyReadingOwner && row.notifyReadingOwner.length > 0) ||
                (row.notifySelf && row.notifySelf.length) > 0) {
                return (
                  <div className="text-center">
                    <table style={{ width: "100%" }}>
                      <tr>
                        <th className="text-center">CareProvider</th>
                        <th className="text-center">Staff</th>
                        <th className="text-center">Patient</th>
                      </tr>
                      <tr>
                        <td>
                          {(row.notifySelf && row.notifySelf.length > 0 && (
                            <div className="text-center">{_.map(_.uniqBy(row.notifySelf), v => _.startCase(v)).toString()} </div>
                          ))}
                          {(!row.notifySelf || row.notifySelf.length == 0 && (
                            <div className="text-center"> - </div>
                          ))}
                        </td>
                         <td>
                          {(row.notifyStaff && row.notifyStaff.length > 0 && (
                            <div className="text-center">{_.map(_.uniqBy(row.notifyStaff), v => _.startCase(v)).toString()} </div>
                          ))}
                          {(!row.notifyStaff || row.notifyStaff.length == 0 && (
                            <div className="text-center"> - </div>
                          ))}
                        </td>
                        <td>
                          {(row.notifyReadingOwner && row.notifyReadingOwner.length > 0 && (
                            <div className="text-center">{_.map(_.uniqBy(row.notifyReadingOwner), v => _.startCase(v)).toString()} </div>
                          ))}
                          {(!row.notifyReadingOwner || row.notifyReadingOwner.length == 0 && (
                            <div className="text-center"> - </div>
                          ))}
                        </td>
                      </tr>
                    </table>
                  </div>
                );
              } else {
                return <div className="text-center">-</div>;
              }
            }
          },
          {
            dataField: "updatedAt",
            text: "Last Updated",
            sort: true,
            formatter: (cell, row) => {
              if (row.updatedAt) {
                return moment(row.updatedAt).tz(moment.tz.guess()).format("MMMM DD, YYYY");
              } else {
                return "NONE";
              }
            },
            headerStyle: (colum, colIndex) => {
              return { padding: "16px", fontSize: "16px", color: "#070707" };
            },
          }
        ]}
        pagination={options.page > 0 ? paginationFactory(options) : undefined}
        bordered
        onTableChange={pagination}
        expandRow={{
          renderer: (row) => { return <div style={{ margin: 15 }}><ExtremeExceptionsDetails details={row} readingTypeAndConditions={readingTypeAndConditions} reload={reloadData} /></div> },
          onlyOneExpanding: false,
          showExpandColumn: true,
          expandByColumnOnly: false,
        }}
      ></BootstrapTable>
      </div>
    </div>
  );
};


export default ExtremeExpectations;